import _ from 'lodash';
import React from 'react';

import ItemContainer from './ItemContainer/ItemContainer';

const Body = ({ list, draggingData }) => {
  return (
    <React.Fragment>
      {list.map((f, i) => {
        const droppableId = JSON.stringify(f);
        const isDropDisabled =
          draggingData?.id === f.id ||
          (draggingData.source === 'folder' && f.source === 'document');

        return (
          <ItemContainer
            key={f.id}
            file={f}
            rowIndex={i}
            droppableId={droppableId}
            isDropDisabled={isDropDisabled}
          />
        );
      })}
    </React.Fragment>
  );
};

export default Body;
